module.exports = __webpack_public_path__ + "static/media/WZ1.f402404e.jpg";